import React, { useState } from "react";
import { Check, Search } from "lucide-react";
import { useI18n, LANGUAGES, REGIONS } from "../i18n";

/* Region-grouped language picker with search — used in onboarding and settings */
export function LanguagePicker({ onPick, compact = false }) {
  const { lang, changeLang } = useI18n();
  const [q, setQ] = useState("");
  const list = LANGUAGES.filter((l) => !q || l.label.toLowerCase().includes(q.toLowerCase()) || l.native.toLowerCase().includes(q.toLowerCase()));
  const pick = (code) => { changeLang(code); onPick?.(code); };
  return (
    <div data-testid="language-picker">
      <div className="relative mb-2">
        <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search language…" className="w-full rl-card pl-9 pr-3 py-2 text-sm outline-none" data-testid="language-search" />
      </div>
      <div className={`${compact ? "max-h-[50vh]" : "max-h-[55vh]"} overflow-y-auto pr-1 space-y-3`}>
        {REGIONS.map((r) => {
          const items = list.filter((l) => l.region === r.id);
          if (!items.length) return null;
          return (
            <div key={r.id} data-testid={`lang-region-${r.id}`}>
              <div className="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1">{r.label}</div>
              <div className="grid grid-cols-2 gap-1.5">
                {items.map((l) => (
                  <button key={l.code} onClick={() => pick(l.code)} data-testid={`onboarding-lang-${l.code}`}
                    className={`px-3 py-2.5 rounded-xl text-sm font-semibold flex items-center justify-between gap-1 ${lang === l.code ? "rl-gold-bg" : "rl-card text-slate-800"}`}>
                    <span className="flex items-center gap-1.5 min-w-0"><span>{l.flag}</span><span className="truncate">{l.native}</span></span>
                    {lang === l.code && <Check className="w-4 h-4 shrink-0" />}
                  </button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
